
// @ts-nocheck


export const localeCodes =  [
  "en",
  "fr",
  "de",
  "es",
  "pt",
  "it",
  "ja",
  "ko",
  "nl",
  "sv"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_995fa198",
      load: () => import("#nuxt-i18n/995fa198" /* webpackChunkName: "locale_en_46json_995fa198" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_ef37d5e7",
      load: () => import("#nuxt-i18n/ef37d5e7" /* webpackChunkName: "locale_fr_46json_ef37d5e7" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_5f5672fd",
      load: () => import("#nuxt-i18n/5f5672fd" /* webpackChunkName: "locale_de_46json_5f5672fd" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_98313ec2",
      load: () => import("#nuxt-i18n/98313ec2" /* webpackChunkName: "locale_es_46json_98313ec2" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_7bc184eb",
      load: () => import("#nuxt-i18n/7bc184eb" /* webpackChunkName: "locale_pt_46json_7bc184eb" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_b846e21d",
      load: () => import("#nuxt-i18n/b846e21d" /* webpackChunkName: "locale_it_46json_b846e21d" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_f48b2314",
      load: () => import("#nuxt-i18n/f48b2314" /* webpackChunkName: "locale_ja_46json_f48b2314" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_2382966c",
      load: () => import("#nuxt-i18n/2382966c" /* webpackChunkName: "locale_ko_46json_2382966c" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_332cd204",
      load: () => import("#nuxt-i18n/332cd204" /* webpackChunkName: "locale_nl_46json_332cd204" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_7b8d2bdd",
      load: () => import("#nuxt-i18n/7b8d2bdd" /* webpackChunkName: "locale_sv_46json_7b8d2bdd" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/d46389f1" /* webpackChunkName: "config_i18n_46config_46ts_d46389f1" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      language: "en-US",
      files: [
        "/root/front/i18n/locales/en.json"
      ]
    },
    {
      code: "fr",
      name: "Français",
      language: "fr-FR",
      files: [
        "/root/front/i18n/locales/fr.json"
      ]
    },
    {
      code: "de",
      name: "Deutsch",
      language: "de",
      files: [
        "/root/front/i18n/locales/de.json"
      ]
    },
    {
      code: "es",
      name: "Español",
      language: "es-ES",
      files: [
        "/root/front/i18n/locales/es.json"
      ]
    },
    {
      code: "pt",
      name: "Português",
      language: "pt-PT",
      files: [
        "/root/front/i18n/locales/pt.json"
      ]
    },
    {
      code: "it",
      name: "Italiano",
      language: "it-IT",
      files: [
        "/root/front/i18n/locales/it.json"
      ]
    },
    {
      code: "ja",
      name: "日本語",
      language: "ja",
      files: [
        "/root/front/i18n/locales/ja.json"
      ]
    },
    {
      code: "ko",
      name: "한국인",
      language: "ko",
      files: [
        "/root/front/i18n/locales/ko.json"
      ]
    },
    {
      code: "nl",
      name: "Dutch",
      language: "nl",
      files: [
        "/root/front/i18n/locales/nl.json"
      ]
    },
    {
      code: "sv",
      name: "Svenska",
      language: "sv",
      files: [
        "/root/front/i18n/locales/sv.json"
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: true,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://staging.groover.co",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: "en-US",
    files: [
      {
        path: "/root/front/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    language: "fr-FR",
    files: [
      {
        path: "/root/front/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutsch",
    language: "de",
    files: [
      {
        path: "/root/front/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Español",
    language: "es-ES",
    files: [
      {
        path: "/root/front/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    name: "Português",
    language: "pt-PT",
    files: [
      {
        path: "/root/front/i18n/locales/pt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    name: "Italiano",
    language: "it-IT",
    files: [
      {
        path: "/root/front/i18n/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    name: "日本語",
    language: "ja",
    files: [
      {
        path: "/root/front/i18n/locales/ja.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ko",
    name: "한국인",
    language: "ko",
    files: [
      {
        path: "/root/front/i18n/locales/ko.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    name: "Dutch",
    language: "nl",
    files: [
      {
        path: "/root/front/i18n/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sv",
    name: "Svenska",
    language: "sv",
    files: [
      {
        path: "/root/front/i18n/locales/sv.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/